var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "search_ipnut"
  }, [_c('van-field', {
    attrs: {
      "label-width": "40",
      "placeholder": _vm.placeholder
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('p', {
          staticClass: "field_title"
        }, [_vm._v(_vm._s(_vm.leftTitle))])];
      },
      proxy: true
    }, {
      key: "left-icon",
      fn: function () {
        return [_c('img', {
          staticClass: "wicon",
          attrs: {
            "src": _vm.leftIconImg,
            "alt": ""
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.value1,
      callback: function ($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };